import React, { useRef, useEffect } from "react";
import { HeroArea } from "../../components/heroArea";

import { Web as web } from "../../assets/expertise";
import { useTranslation } from "react-i18next";
import "./expertise.css";

export const Web = () => {
  const { t } = useTranslation();
  const section = useRef(null);
  useEffect(() => {
    section.current.scrollIntoView();
  }, []);
  return (
    <>
      <HeroArea />

      <div ref={section} className="service--container container">
        <h2>{t("service.web.title1")}</h2>
        <div className="service--content">
          <p className="paragraph">{t("service.web.paragraph1")}</p>
          <img src={web} alt="web" className="service--img" />
        </div>
        <br />
        <div className="service--second--content">
          <h3>{t("service.methodology")}</h3>
          <h4>1 - {t("service.web.title2")}</h4>
          <p className="paragraph">{t("service.web.paragraph2")}</p>
          <h4>2 - {t("service.web.title3")}</h4>
          <p className="paragraph">{t("service.web.paragraph3")}</p>
          <h4>3 - {t("service.web.title4")}</h4>
          <p className="paragraph">{t("service.web.paragraph4")}</p>
          <h4>4 - {t("service.web.title5")}</h4>
          <p className="paragraph">{t("service.web.paragraph5")}</p>
          <h4>5 - {t("service.web.title6")}</h4>
          <p className="paragraph">{t("service.web.paragraph6")}</p>
        </div>
      </div>
    </>
  );
};
